<template>
  <div class="root-warp">
    <div class="body-box">
      <div class="header">
        <div class="school-title">{{ scoolName }}</div>

        <div class="box-abc">
          <div class="left-block">
            <div class="notice">
              <div class="laba-img"></div>
              <div class="text">{{ noticeText }}</div>
            </div>
          </div>
          <div class="right-block">
            <div class="date">{{ currentTime.date }}</div>
            <div class="week">{{ currentTime.week }}</div>
            <div class="time">{{ currentTime.time }}</div>
          </div>
        </div>
        <div class="status">
          <div :class="['footer-item', item.class]" v-for="item of footerArr" :key="item.text">
            <span class="block"></span>
            <span style="margin-left:5px">{{ item.text }}</span>
          </div>
        </div>

      </div>

      <div :class="['weifx', 'item-box']">
        <div class="title">
          <img src="@/assets/images/0.png" alt="">
          未放学
          <template v-if="isShowCaret[0]">
            <i v-if="isSpread0" class="el-icon-caret-top" @click="fold(0)"></i>
            <i v-else class="el-icon-caret-bottom" @click="spread(0)"></i>
          </template>
        </div>
        <div class="content" id="content0">
          <span class="item" :style="{width:item.className.length > 5 ? Math.ceil(item.className.length/6)  * 10 + 'rem' : '10rem'}" v-for="item of weifxArr" :key="item.id">{{ item.className }}</span>
        </div>
      </div>
      <div :class="['fxzhong', 'item-box']">
        <div class="title">
          <img src="@/assets/images/1.png" alt="">
          放学中
          <template v-if="isShowCaret[1]">
            <i v-if="isSpread1" class="el-icon-caret-top" @click="fold(1)"></i>
            <i v-else class="el-icon-caret-bottom" @click="spread(1)"></i>
          </template>
        </div>
        <div class="content" id="content1">
          <span class="item" :style="{width:item.className.length > 5 ? Math.ceil(item.className.length/6)  * 10 + 'rem' : '10rem'}" v-for="item of fxzhongArr" :key="item.id">{{ item.className }}</span>
        </div>
      </div>
      <div :class="['yifx', 'item-box']">
        <div class="title">
          <img src="@/assets/images/2.png" alt="">
          已放学
          <template v-if="isShowCaret[2]">
            <i v-if="isSpread2" class="el-icon-caret-top" @click="fold(2)"></i>
            <i v-else class="el-icon-caret-bottom" @click="spread(2)"></i>
          </template>
        </div>
        <div class="content" id="content2">
          <span class="item" :style="{width:item.className.length > 5 ? Math.ceil(item.className.length/6)  * 10 + 'rem' : '10rem'}" v-for="item of yifxArr" :key="item.id">{{ item.className }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myMixin from "./mixin/index.js";

export default {
  mixins: [myMixin],
  mounted() {
    function fontSize() {
      var deviceWidth = document.documentElement.clientWidth;
      document.documentElement.style.fontSize = (deviceWidth / 41.4) + "px";
      console.log((deviceWidth / 41.4) + "px");
    }
    fontSize();
    window.onresize = fontSize;
  }
};
</script>

<style lang='scss' scoped>
@mixin hvCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}

.root-warp {
  width: 100vw;
  padding: 0;
  font-weight: normal;

  .body-box {
    width: 100%;
    min-height: 100vh; // 控制整体的最小高度
    // border: 1px solid red;
    background: #f9f9f9;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    .header {
      height: auto;
      width: 100%;
      background: linear-gradient(to bottom right, #63c689, #479fd3);
      border-radius: 0 0 5rem 5rem;

      margin-bottom: 3rem;

      .school-title {
        margin-top: 0.5rem;
        font-size: 3.5rem;
        font-weight: bold;
        color: white;
        @include hvCenter;
        text-shadow: 0.35rem 0.35rem 0.4rem #070707;
        padding: 0 1rem;
      }

      .box-abc {
        display: flex;

        .left-block {
          width: 70%;

          .notice {
            height: 10rem;
            color: #ffff00;
            font-size: 1.5rem;
            @include hvCenter;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .laba-img {
              width: 6rem;
              height: 6rem;
              background: white url("~@/assets/images/laba1.png") no-repeat center;
              background-size: 60% 60%;
              border-radius: 50%;
              margin-left: 1rem;
            }

            .text {
              width: 70%;
              font-size: 2.2rem;
              line-height: 3.5rem;
            }
          }

        }

        .right-block {
          width: 30%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-size: 2rem;
          color: white;

          .week {
            margin: 0.5rem auto;
          }

          .time {
            font-size: 2.2rem;
          }

          div {
            text-align: center;
          }
        }
      }

      .status {
        height: 5rem;
        width: 90%;
        background: white;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 2rem;
        border-radius: 1rem;
        position: relative;
        top: 1.5rem;
        left: 2rem;
        box-shadow: 0 0.2rem 1.2rem 0 rgba(0, 0, 0, .1);
        border: .1rem solid #ebeef5;
        color: #737373;

        .footer-item {
          width: 30%;
          display: flex;
          justify-content: center;
          align-items: center;

          .block {
            display: inline-block;
            width: 3rem;
            height: 3rem;
            border-radius: 50%;
          }
        }

        .redC {

          // color: #ff0000;
          .block {
            background: #ff0000;
          }
        }

        .purpleC {

          // color: #c6f;
          .block {
            background: #fc5de1;
          }
        }

        .greenC {

          // color: #3f3;
          .block {
            background: #00ff6f;
          }
        }
      }

    }


    // 下面三个放学状态盒
    .item-box {
      min-height: 13rem;
      width: 90%;
      border-radius: 1rem;
      margin-bottom: 1.5rem;
      box-shadow: 0 0.2rem 1.2rem 0 rgba(0, 0, 0, .1);
      border: .1rem solid #ebeef5;
      color: #737373;
      transition: all .5s;
      height: 13rem;
      overflow: hidden;

      .title {
        font-size: 1.8rem;
        height: 4rem;
        border-bottom: .1rem solid #ebeef5;
        display: flex;
        align-items: center;

        img {
          width: 2.4rem;
          height: 2.4rem;
          margin: 0 1rem;
        }

        i {
          font-size: 3rem;
          margin-left: 22rem;
          color: #c9c9c9;
        }
      }

      .content {

        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-flow: row wrap;
        font-size: 1.6rem;
        padding: 0.8rem 0.8rem 0 0.8rem;

        .item {
          width: 10rem;
          height: 3rem;
          background: #ececec;
          border-radius: 2rem;
          margin-bottom: 1rem;
          @include hvCenter()
        }
      }
    }

    .partShow {
      height: 13rem;
      overflow: hidden;
    }

    .weifx {
      // color: #ff0000;
    }

    .fxzhong {
      // color: #c6f;
    }

    .yifx {
      // color: #3f3;
    }
  }
}</style>
